function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M325.567 0H24l25.433 20L24 40h301.567L351 20 325.567 0z",
  fill: "#ECCEFC"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.567 0H-285l25.433 20L-285 40H16.567L42 20 16.567 0z",
  fill: "#ECCEFC"
});

function SvgEndArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 351 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzUxIDQwIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogICAgPHBhdGggZD0iTTMyNS41NjcgMEgyNEw0OS40MzMzIDIwTDI0IDQwSDMyNS41NjdMMzUxIDIwTDMyNS41NjcgMFoiIGZpbGw9IiNFQ0NFRkMiIC8+CiAgICA8cGF0aCBkPSJNMTYuNTY2NyAwSC0yODVMLTI1OS41NjcgMjBMLTI4NSA0MEgxNi41NjY3TDQyIDIwTDE2LjU2NjcgMFoiIGZpbGw9IiNFQ0NFRkMiIC8+Cjwvc3ZnPgogICAg";
export { SvgEndArrow as ReactComponent };